var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "employee-page" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("span", [_vm._v("员工管理")]),
          _c(
            "el-button",
            {
              staticClass: "fr addBtn",
              attrs: { type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("添加员工")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-card" },
        [
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "EmployeeListable",
            attrs: {
              "keep-scroll-pos": "",
              data: _vm.employeeList,
              columns: _vm.columns,
              pagination: _vm.pagination,
              height: _vm.tableHeight,
              size: "mini",
              selection: true,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.handlePageChange,
              "selection-change": _vm.handleSelectionChange,
            },
            scopedSlots: _vm._u([
              {
                key: "status",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.status ? "启用" : "停用") + " "),
                  ]
                },
              },
              {
                key: "operation",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row.userId)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function () {
                            return _vm.handleDelete(row.userId)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Dialog", {
        ref: "empDialog",
        attrs: { title: _vm.title, vstatus: _vm.vstatus },
        on: { getEmps: _vm.getEmployee },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }